// path:
import { SuppliersExhibitionType } from '../../../../../store/useSuppliersExhibitionStore';

/** O agrupamento em que cada produto aparece numa linha só, consolidando todas as lojas do cliente. */
const NETWORK_EXHIBITION_TYPE: SuppliersExhibitionType = 'PRODUCT_SUPPLIERS_NETWORK';

/** As chaves dos dois filtros que o agrupamento por toda a rede não oferece: */
export const HIDDEN_FILTER_KEYS_IN_NETWORK_VIEW = ['storeIds', 'clusters'];

/** As chaves que o modelo de requisição não pode carregar no agrupamento por toda a rede. */
const HIDDEN_REQUEST_MODEL_KEYS = [...HIDDEN_FILTER_KEYS_IN_NETWORK_VIEW, 'clusterIds'];

/** A lista de filtros que a visão oferece, a partir da lista completa. */
export const resolveVisibleFilters = <T extends { key: string }>(filters: T[], suppliersExhibitionType: SuppliersExhibitionType): T[] => {
  if (suppliersExhibitionType !== NETWORK_EXHIBITION_TYPE) return filters;

  return filters.filter(({ key }) => !HIDDEN_FILTER_KEYS_IN_NETWORK_VIEW.includes(key));
};

/** O modelo de requisição sem as chaves que a visão não pode carregar. */
export const stripHiddenFiltersFromRequestModel = <T extends object>(model: T, suppliersExhibitionType: SuppliersExhibitionType): T => {
  if (suppliersExhibitionType !== NETWORK_EXHIBITION_TYPE) return model;

  const remainingModel = { ...model } as Record<string, unknown>;
  HIDDEN_REQUEST_MODEL_KEYS.forEach(key => delete remainingModel[key]);

  return remainingModel as T;
};
